import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertMessageComponent, AlertModule as CosoAlertModule } from "@coso/alert";
import { FormsModule as CosoFormsModule } from "@coso/forms";
import { GridModule } from "@coso/grid";
import { LoggerModule } from "@coso/logger";
import { UtilityModule } from "@coso/utility";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { AlertModule } from "ngx-bootstrap/alert";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PageHeaderModule } from "../page-header/page-header.module";
import { EditConfigurationComponent } from "./components/edit-configuration/edit-configuration.component";
import { ListConfigurationsActionsCellRendererComponent } from "./components/list-configurations/list-configurations-actions-cell-renderer/list-configurations-actions-cell-renderer.component";
import { ListConfigurationsComponent } from "./components/list-configurations/list-configurations.component";
import { ConfigurationRoutingModule } from "./configuration-routing.module";
import { ConfigurationExistsGuard } from "./guards/configuration-exists.guard";
import { GroupStorageGuard } from "./guards/group-storage.guard";
import { HostGuard } from "./guards/host.guard";
import { SharePointExistsGuard } from "./guards/sharepoint-exists.guard";
import { StatusGuard } from "./guards/status.guard";
import { LogsModule } from "./logs/logs.module";
import {AutomaticSharepointUserCreationGuard} from "./guards/automatic-sharepoint-user-creation.guard";
import { CosoTokenActivation } from "@coso/saas-angular";

@NgModule({
  declarations: [ListConfigurationsComponent, EditConfigurationComponent, ListConfigurationsActionsCellRendererComponent],
  imports: [
    CommonModule,
    ConfigurationRoutingModule,
    CosoAlertModule,
    PageHeaderModule,
    AlertModule,
    PaginationModule,
    ReactiveFormsModule,
    FormsModule,
    LoggerModule,
    TooltipModule,
    UtilityModule,
    CosoFormsModule,
    GridModule,
    NgbDropdownModule,
    AlertMessageComponent,
    CosoTokenActivation
  ],
  exports: [LogsModule],
  providers: [HostGuard, GroupStorageGuard, StatusGuard, ConfigurationExistsGuard, AutomaticSharepointUserCreationGuard, SharePointExistsGuard]
})
export class ConfigurationModule {}
